import type React from "react";

import { useStore } from "@/store";
import { Navigate, useLocation } from "react-router-dom";
import EmailVerificationGuard from "./EmailVerificationGuard";
import { Spinner } from "./ui/spinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { currentUser, isUserLoading } = useStore();
  const location = useLocation();

  if (isUserLoading) {
    return (
      <div className="flex items-center justify-center h-screen-mobile">
        <Spinner variant="circle" />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <EmailVerificationGuard>{children}</EmailVerificationGuard>;
};
